<template>
  <div class="map-background">
    <div class="login-box">
      <div class="card card-login">
        <div class="card-body">
          <div class="row">
            <div class="col-12 text-center">
              <h2>Reset Your Password</h2>
            </div>
            <div class="col-12">
              <form @submit.prevent="resetPassword">
                <p class="text-center">
                  Enter your email address and get your new password.
                </p>

                <div v-if="hasGlobalErrors" class="alert alert-dismissible alert-danger">
                  <button type="button" class="close" data-dismiss="alert">×</button>
                  {{ errors.token }}
                  {{ errors.nonFieldErrors }}
                  {{ errors.detail }}
                </div>
                <div v-if="successFeedback" class="alert alert-dismissible alert-success">
                  {{ successFeedback }}
                </div>

                <div :class="{ 'form-group': true, 'has-error': errors.email }">
                  <div class="input-group">
                    <div class="input-group-addon">
                      <i class="material-icons">email</i>
                    </div>
                    <input
                      type="email"
                      class="input-lg form-control"
                      name="email"
                      placeholder="Email"
                      autofocus
                      v-model="email"
                      :disabled="disabled"
                    />
                  </div>
                  <div class="error-msg">{{ errors.email }}</div>
                </div>

                <router-link to="/login">
                  <button type="button" class="btn btn-raised btn-default">
                    Go back
                  </button>
                </router-link>
                <button
                  type="submit"
                  class="btn btn-raised btn-primary float-right"
                  :disabled="disabled"
                >
                  Reset Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formController from '../controllers/form'
import User from '../models/user'

export default {
  extends: formController,
  data() {
    return {
      email: '',
      successMessage:
        'You will receive an email with instructions on how to reset your password.'
    }
  },
  methods: {
    resetPassword() {
      this.disabled = true
      User.resetPassword(this.email)
        .done(this.succeed)
        .fail(this.failed)
        .always(this.always)
    }
  }
}
</script>
